import { Component, OnInit, TemplateRef } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.css']
})
export class PersonalInfoComponent implements OnInit {
  video: String = 'assets/videos/Emotive registration tutorial.mp4';
  videoStatus: Boolean = false;
  constructor(
  	private apiService: ApiService,
    private modalService: BsModalService,
    public translations: TranslationService
  ) { }

  ngOnInit() {
    this.apiService.getClient().subscribe((res: any) => {
      if (res.data.video) {
        this.video = res.data.video;
      } 
    });
  }

  modalRef: BsModalRef;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'tour-modal tutorial' });
  }
  
  toggleVideo(video){
    !this.videoStatus ? video.play() : video.pause();
    this.videoStatus = !this.videoStatus;
  }
}
